const GET_STEP_MULTIMEDIA = 'publicador/step2Module1/GET_STEP_MULTIMEDIA';
const SAVE_STEP_MULTIMEDIA = 'publicador/step2Module1/SAVE_STEP_MULTIMEDIA';
const ADD_MULTIMEDIA = 'publicador/step2Module1/ADD_MULTIMEDIA';
const MOVE_MULTIMEDIA = 'publicador/step2Module1/MOVE_MULTIMEDIA';
const DELETE_MULTIMEDIA = 'publicador/step2Module1/DELETE_MULTIMEDIA';
const UPDATE_MULTIMEDIA = 'publicador/step2Module1/UPDATE_MULTIMEDIA';
const PROCESSING_MULTIMEDIA = 'publicador/step2Module1/PROCESSING_MULTIMEDIA';
const BULK_ACTION_MULTIMEDIA = 'publicador/step2Module1/BULK_ACTION_MULTIMEDIA';
const ADD_ERROR_MULTIMEDIA = 'publicador/step2Module1/ADD_ERROR_MULTIMEDIA';
const CLEAN_MULTIMEDIA = 'publicador/step2Module1/CLEAN_MULTIMEDIA';

export {
  GET_STEP_MULTIMEDIA,
  SAVE_STEP_MULTIMEDIA,
  ADD_MULTIMEDIA,
  MOVE_MULTIMEDIA,
  DELETE_MULTIMEDIA,
  UPDATE_MULTIMEDIA,
  BULK_ACTION_MULTIMEDIA,
  PROCESSING_MULTIMEDIA,
  ADD_ERROR_MULTIMEDIA,
  CLEAN_MULTIMEDIA
};
